"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = getConfig;
var _error = require("./error");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Get Config
 * - Gets the SDK configuration
 *
 * @module core-bootstrap-get-config
 */

/**
* Resolve configuration object
*
* side effects:
*   decomposes some URLs and adds component parts to internal configuration
*   sets the iframe target origin internal configuration
*
* @param {*} [config] Optional configuration object passed in to SDK initialize call.
* @return {boolean} true if configuration is valid, false otherwise
*/
function getConfig(config) {
  // if we are supplied a config, use it
  if (config) {
    return config;
  }

  // if we are not supplied a config, check the global variable
  if (window.WF_AO_SDK_Config) {
    return window.WF_AO_SDK_Config;
  }

  // otherwise throw an error
  (0, _error.handleError)('There is no WF_AO_SDK_Config object so the SDK cannot be loaded.');
  return false;
}
//# sourceMappingURL=get-config.js.map